import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=2da24fea"
import script from "./BarcodeScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./BarcodeScanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BarcodeScanner.vue?vue&type=style&index=0&id=2da24fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports